/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import 'semantic-ui-css/semantic.min.css';
import App from './App';
import './index.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import messages_fr from "./translations/fr.json";
import messages_en from "./translations/en.json";
import messages_it from "./translations/it.json";
import messages_es from "./translations/es.json";
import messages_nl from "./translations/nl.json";
import messages_pt from "./translations/pt.json";
import { IntlProvider } from "react-intl";
import 'bootstrap/dist/css/bootstrap.min.css';

const messages = {
    'fr': messages_fr,
    'en': messages_en,
    'it': messages_it,
    'es': messages_es,
    'nl': messages_nl,
    'pt': messages_pt
};
const language = navigator.language.split(/[-_]/)[0];  // language without region code

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
<IntlProvider locale={language} messages={messages[language]}><App /></IntlProvider>
);